import { useSecureFileUrl, useHEICPreviewUrl } from "@tellescope/tanstack-query";
import { isHEICType } from "@tellescope/utils";
import { FileImagePreview } from "./FileImagePreview";
import { FilePreviewTile } from "./FilePreviewTile";

interface FileUploadedItemPreviewProps {
  name: string;
  secureName: string;
  type?: string;
}

export const FileUploadedItemPreview = ({ name, secureName, type }: FileUploadedItemPreviewProps) => {
  const url = useSecureFileUrl(secureName);
  const isHEIC = isHEICType(type);
  const previewUrl = useHEICPreviewUrl(url, isHEIC, secureName);
  const isImage = type?.startsWith("image/");

  if (!isImage) {
    return <FilePreviewTile />;
  }

  if (!previewUrl) {
    return <FilePreviewTile variant="loading" />;
  }

  return <FileImagePreview src={previewUrl} alt={name} />;
};
